class PredictiveSearch extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
    }, 300).bind(this));

    this.input.addEventListener('click', () => {
      this.onChange();
    });

    this.predictiveSearchResults.addEventListener('mouseleave', () => {
      this.close();
    });

    this.predictiveSearchResults.addEventListener('focusout', () => {
      this.close();
    });
  };

  offset(el) {
    let box = el.getBoundingClientRect();
    let docElem = document.documentElement;
    return {
      top: box.top + window.pageYOffset - docElem.clientTop,
      left: box.left + window.pageXOffset - docElem.clientLeft
    };
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }

    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {
    fetch(`/search/suggest?q=${searchTerm}&resources[limit]=3&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,variants.sku&section_id=predictive-search`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
    if (!(this.classList.contains('search-page')) && !(this.classList.contains('mobile'))) {
      this.predictiveSearchResults.style.position = 'fixed';
      let inputOffset = this.offset(this.input);
      let inputOffsetTop = inputOffset.top;
      let inputHeight = parseInt(this.input.offsetHeight);
      let searchResultsTop = inputOffsetTop + inputHeight + 10;
      let searchResultsLeft = inputOffset.left;
      this.predictiveSearchResults.style.top = searchResultsTop + 'px';
      this.predictiveSearchResults.style.left = searchResultsLeft + 'px';
    }
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}
  
customElements.define('predictive-search', PredictiveSearch);
  